var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeEvery, select, delay, takeLatest, } from "redux-saga/effects";
import { isEqual } from "lodash";
import { CHATBOT_INJECT, CHATBOT_INJECT_SUCCESS, CHATBOT_OPEN, addAttributes, updateAttributes, injectChatbotError, injectChatbotSuccess, initChatbotError, initChatbot, openChatbotError, openChatbotSuccess, CHATBOT_LOG_INTAKE, logChatIntakeError, COMMON_BENEFITS_SUCCESS, COMMON_BENEFITS_FAILED, NO_COMMON_BENEFITS, CHATBOT_UPDATE_ATTRIBUTES, updateAttributesError, updateAttributesSuccess, } from "../action";
import { getAmazonConnectSelector, getPrimaryLookup, getBenefitsOperator, getLookupNames, getRescueSubmitted, getChatbotStatus, getSessionId, getUsageId, getChatbotFeatureFlag, getChatAttributes, getPartnerCode, } from "../selector";
import { AMAZON_CONNECT_CHAT_USER_TYPE } from "../app-consts/appConstants";
import { getAttributeNames } from "../screens/CommonLookup/commonLookupHelper";
import { getChatbotContactIdFromLocalStorage, getSearchQueryFromURL, getVaChat, promiseInjectAmazonConnect, updateChatbotAttributes, } from "../utils";
import { datadogRum } from "@datadog/browser-rum";
export function injectChatbotSaga() {
    var amazonConnect, isInjected, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 7]);
                return [4 /*yield*/, select(getAmazonConnectSelector)];
            case 1:
                amazonConnect = _a.sent();
                return [4 /*yield*/, call(promiseInjectAmazonConnect, amazonConnect)];
            case 2:
                isInjected = _a.sent();
                if (!isInjected) return [3 /*break*/, 4];
                return [4 /*yield*/, put(injectChatbotSuccess())];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 7];
            case 5:
                e_1 = _a.sent();
                console.log(e_1);
                return [4 /*yield*/, put(injectChatbotError())];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function initializeChatSaga() {
    var amazonConnect, rescueSubmitted, usageId, partnerCode, isAMCJJMemberPath, defaultAttr, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 9]);
                return [4 /*yield*/, select(getAmazonConnectSelector)];
            case 1:
                amazonConnect = _a.sent();
                return [4 /*yield*/, select(getRescueSubmitted)];
            case 2:
                rescueSubmitted = _a.sent();
                return [4 /*yield*/, select(getUsageId)];
            case 3:
                usageId = _a.sent();
                return [4 /*yield*/, select(getPartnerCode)];
            case 4:
                partnerCode = _a.sent();
                isAMCJJMemberPath = partnerCode === "AMC" || partnerCode === "JJ";
                defaultAttr = {
                    attributes: {
                        usageId: usageId,
                        userType: AMAZON_CONNECT_CHAT_USER_TYPE,
                        va_botname: amazonConnect === null || amazonConnect === void 0 ? void 0 : amazonConnect.botName,
                        submission: isAMCJJMemberPath ? (!rescueSubmitted ? "N" : "Y") : "Y",
                    },
                };
                return [4 /*yield*/, put(addAttributes(defaultAttr.attributes))];
            case 5:
                _a.sent();
                getVaChat().set(defaultAttr);
                return [4 /*yield*/, put(initChatbot())];
            case 6:
                _a.sent();
                getVaChat().initializeChat();
                return [3 /*break*/, 9];
            case 7:
                e_2 = _a.sent();
                return [4 /*yield*/, put(initChatbotError())];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function openChatSaga() {
    var chatbotStatus, attr, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 7]);
                return [4 /*yield*/, select(getChatbotStatus)];
            case 1:
                chatbotStatus = _a.sent();
                chatbotStatus == "INITIALIZED" && getVaChat().open();
                return [4 /*yield*/, select(getChatAttributes)];
            case 2:
                attr = _a.sent();
                datadogRum.addAction("Start Chat with Attributes", __assign({}, attr));
                return [4 /*yield*/, put(openChatbotSuccess())];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4:
                e_3 = _a.sent();
                return [4 /*yield*/, put(openChatbotError())];
            case 5:
                _a.sent();
                return [4 /*yield*/, delay(1500)];
            case 6:
                _a.sent();
                getVaChat().open();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function logChatIntakeResultsSaga(action) {
    var experimentGroup, actionName_1, conversationId, serviceRequestPayloadUsageId, sessionId, pathName, usageId_1, contactId_1, data_1, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4 /*yield*/, select(getChatbotFeatureFlag)];
            case 1:
                experimentGroup = _a.sent();
                actionName_1 = action.payload;
                conversationId = getSearchQueryFromURL("conversationId");
                return [4 /*yield*/, select(getUsageId)];
            case 2:
                serviceRequestPayloadUsageId = _a.sent();
                return [4 /*yield*/, select(getSessionId)];
            case 3:
                sessionId = _a.sent();
                pathName = window.location.href;
                usageId_1 = localStorage.getItem("usageId") || serviceRequestPayloadUsageId || "";
                contactId_1 = getChatbotContactIdFromLocalStorage();
                data_1 = {
                    sessionId: sessionId,
                    pathName: pathName,
                    conversationId: conversationId,
                    usageId: usageId_1,
                    contactId: contactId_1,
                    experimentGroup: experimentGroup ? "Experiment" : "Control",
                };
                if (action.payload == "Chat Button Clicked") {
                    document.addEventListener("onChatClick", function chatOpenEventListener() {
                        data_1.usageId = usageId_1 || localStorage.getItem("usageId");
                        data_1.contactId = contactId_1 || getChatbotContactIdFromLocalStorage();
                        datadogRum.addAction(actionName_1, data_1);
                        document.removeEventListener("onChatClick", chatOpenEventListener);
                    });
                }
                else {
                    datadogRum.addAction(actionName_1, data_1);
                }
                return [3 /*break*/, 6];
            case 4:
                e_4 = _a.sent();
                return [4 /*yield*/, put(logChatIntakeError(e_4))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
export function updateChatAttributesSaga() {
    var chatbotStatus, chatBotAttributes, newAttributes, chatbotContactId, newUsageId, newSessionId, isPrimaryLookup, operators, lookupName, attrName;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getChatbotStatus)];
            case 1:
                chatbotStatus = _a.sent();
                if (!(chatbotStatus == "INITIALIZED")) return [3 /*break*/, 9];
                return [4 /*yield*/, select(getChatAttributes)];
            case 2:
                chatBotAttributes = _a.sent();
                newAttributes = __assign({}, chatBotAttributes);
                chatbotContactId = getChatbotContactIdFromLocalStorage();
                return [4 /*yield*/, select(getUsageId)];
            case 3:
                newUsageId = _a.sent();
                return [4 /*yield*/, select(getSessionId)];
            case 4:
                newSessionId = _a.sent();
                return [4 /*yield*/, select(getPrimaryLookup)];
            case 5:
                isPrimaryLookup = _a.sent();
                return [4 /*yield*/, select(getBenefitsOperator)];
            case 6:
                operators = _a.sent();
                return [4 /*yield*/, select(getLookupNames)];
            case 7:
                lookupName = _a.sent();
                attrName = void 0;
                if (lookupName !== undefined &&
                    (lookupName.lastName || lookupName.firstName)) {
                    attrName = getAttributeNames(isPrimaryLookup, lookupName, operators);
                }
                if (!chatBotAttributes.usageId && newUsageId) {
                    newAttributes.usageId = newUsageId;
                }
                if (!chatBotAttributes.sessionId && newSessionId !== "") {
                    newAttributes.sessionId = newSessionId;
                }
                if (!!isEqual(chatBotAttributes, newAttributes)) return [3 /*break*/, 9];
                if (!chatBotAttributes.contactId && chatbotContactId !== "") {
                    newAttributes.contactId = chatbotContactId;
                }
                datadogRum.addAction("Update chat attributes", {
                    oldAttrs: chatBotAttributes,
                    newAttrs: newAttributes,
                });
                return [4 /*yield*/, put(updateAttributes(__assign(__assign({}, newAttributes), attrName)))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}
export function updateChatbotAttributesSaga(action) {
    var e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 4]);
                updateChatbotAttributes(action.payload);
                return [4 /*yield*/, put(updateAttributesSuccess())];
            case 1:
                _a.sent();
                return [3 /*break*/, 4];
            case 2:
                e_5 = _a.sent();
                return [4 /*yield*/, put(updateAttributesError())];
            case 3:
                _a.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
export function watchChatbotSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(CHATBOT_INJECT, injectChatbotSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(CHATBOT_INJECT_SUCCESS, initializeChatSaga)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(CHATBOT_OPEN, openChatSaga)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(CHATBOT_LOG_INTAKE, logChatIntakeResultsSaga)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest([COMMON_BENEFITS_SUCCESS, COMMON_BENEFITS_FAILED, NO_COMMON_BENEFITS], updateChatAttributesSaga)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(CHATBOT_UPDATE_ATTRIBUTES, updateChatbotAttributesSaga)];
            case 6:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
